import { DefaultResType } from "../../types/common/response";
import { baseApi } from "../../util/axiosConfig";

const url = "api/admin/account/";

export async function readAccountApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_user_account", data);
  } catch (err: any) {
    return err?.response;
  }
}

export async function updateAccountApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "update_user_account", data);
  } catch (err: any) {
    return err?.response;
  }
}

export async function createAccountApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "create_user_account", data);
  } catch (err: any) {
    return err?.response;
  }
}

export async function deleteAccountApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "delete_user_account", data);
  } catch (err: any) {
    return err?.response;
  }
}


export async function detailAccountApi(data: any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_user_account_detail", data);
  } catch (err: any) {
    return err?.response;
  }
}

export async function readUserAccountDetailByTokenApi(): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_user_account_detail_by_token", {});
  } catch (err: any) {
    return err?.response;
  }
}

export async function updateUserPasswordApi(data:any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "update_user_password", data);
  } catch (err: any) {
    return err?.response;
  }
}

export async function readCrmTeamListApi(): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_crm_team_list");
  } catch (err: any) {
    return err?.response;
  }
}

export async function readCrmBusinessUnitListApi(): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "read_crm_business_unit_list");
  } catch (err: any) {
    return err?.response;
  }
}

export async function updateUserCrmIdApi(data:any): Promise<DefaultResType> {
  try {
    return await baseApi.post(url + "update_user_crm_id", data);
  } catch (err: any) {
    return err?.response;
  }
}